var _a;
import { COLUMNS_NAME } from "../../constants";
export var columnWidthsConfig = (_a = {},
    _a[COLUMNS_NAME.LIST_NAME] = '250px',
    _a[COLUMNS_NAME.SOURCE] = '170px',
    _a[COLUMNS_NAME.RECORD_TYPE] = '200px',
    _a);
